import { apiRequest } from '../utils/axios';

export async function rateCourse(data: { courseId: string; rating: number }): Promise<void> {
  return apiRequest('POST', `/my-course-ratings/`, data);
}
